export const translate = {
    labels: {
        translate: "Tradução",
        translations: "Traduções",
        add_translate: "Adicionar Tradução",
        delete_translate: "Deletar Tradução",
    },
    placeholders: {
    },
    modals: {
        titles: {
        },
        messages: {
        },
    },
    texts: {
        empty: "Não há traduções para exibir",
        add_translate: "Você deseja adicionar uma tradução?",
        delete_translate: "Você deseja deletar esta tradução?<br/>Esta ação não pode ser desfeita.",
    },
};
